module.exports = __webpack_public_path__ + "static/media/4ODA5.93f37e68.jpg";